import { Endpoint } from "../config";

export type MasterEndpointType =
  | "commodity"
  | "profession"
  | "debtorType"
  | "paymentTerms"
  | "clientType"
  | "bank"
  | "commodityArchive"
  | "professionArchive"
  | "debtorTypeArchive"
  | "paymentTermsArchive"
  | "clientTypeArchive"
  | "bankArchive";

export const masterEndpoints: Record<MasterEndpointType, Endpoint> = {
  commodity: {
    url: "commodity/",
  },
  profession: {
    url: "profession/",
  },
  debtorType: {
    url: "debtor-type/",
  },
  paymentTerms: {
    url: "payment-term/",
  },
  clientType: {
    url: "client-type/",
  },
  bank: {
    url: "bank/",
  },
  commodityArchive: {
    url: "commodity",
  },
  professionArchive: {
    url: "profession",
  },
  debtorTypeArchive: {
    url: "debtor-type",
  },
  paymentTermsArchive: {
    url: "payment-term",
  },
  clientTypeArchive: {
    url: "client-type",
  },
  bankArchive: {
    url: "bank",
  },
};
